// /src/pages/private/members/dashboard/dashboardUtils.js

export function displayMoniker(player) {
    if (!player) return '—';
  
    if (player.monikerRedacted) {
      return player.monikerRedactedKind === 'redacted' ? 'Redacted' : 'Hidden';
    }
  
    return player.rosterMoniker || '—';
  }
  
  export function displayHandle(player) {
    if (!player?.rosterHandle) return '—';
    return `@${player.rosterHandle}`;
  }
  
export function isContractorRank(rankName) {
    return /contractor/i.test(String(rankName || ''));
}

export function getCurrentPromotionSource(promotions) {
    if (!Array.isArray(promotions) || !promotions.length) return null;
    const last = promotions[promotions.length - 1];
    return last?.promotionSource || 'auto';
}

export function pickPrimaryHandleIdFromHandleList(list) {
    if (!Array.isArray(list) || !list.length) return null;

    const linked = list.filter((h) => h && h.linkedToUser === true);
    const scope = linked.length > 0 ? linked : list;

    const master = scope.find((h) => h && h.isMaster !== false);
    const pick = master || scope[0];
    const id = Number(pick?.handleId ?? pick?.id);

    return Number.isInteger(id) && id > 0 ? id : null;
  }

/** True when the user has a direct master-handle link (full playerId cluster on dashboard). */
export function linkedHandlesIncludeMaster(list, { isViewAsActive = false } = {}) {
  if (!Array.isArray(list) || !list.length) return false;
  const scope = isViewAsActive
    ? list
    : list.filter((h) => h && h.linkedToUser);
  return scope.some((h) => h && h.isMaster !== false);
}